import React, {useEffect, useMemo} from "react"
import {Descriptions, Grid} from "antd"
import {Helmet} from "react-helmet-async"
import {useDispatch, useSelector} from "react-redux"
import {NavLink, useHistory, useParams} from "react-router-dom"
import {StateType} from "../../store/store"
import {BackButton} from "../../components/BackButton/BackButton"
import {Loading} from "../../components/Loading/Loading"
import moment from "moment/moment"
import {getPSLeakDeviceLog, setPSLeakDeviceLog, setWSPSLeakDeviceLog} from "../../store/psLeakDeviceLogReducer"
import {getTimeZoneDiffString} from "../../helps/timezoneDiff"

const {useBreakpoint} = Grid

export const PSLeakDeviceLog = () => {
    const dispatch = useDispatch()
    const history = useHistory()
    const id = parseInt(useParams<{ id: string }>()?.id, 10)
    const log = useSelector((state: StateType) => state.psLeakDeviceLogReducer.psLeakDeviceLog)
    const ws = useSelector((state: StateType) => state.psLeakDeviceLogReducer.ws)
    const controller = useMemo(() => new AbortController(), [id])
    const {lg} = useBreakpoint()

    useEffect(() => {
        if (id) dispatch(getPSLeakDeviceLog({id, controller}))

        return () => {
            controller.abort()
            dispatch(setPSLeakDeviceLog(null))
        }
    }, [dispatch, id, controller])

    useEffect(() => {
        if (ws && ws.id === id) {
            dispatch(getPSLeakDeviceLog({id, controller, withoutLoadingIndicator: true}))
        }
        dispatch(setWSPSLeakDeviceLog(null))
    }, [dispatch, ws, id, controller])

    if (!log) return <Loading/>

    return (
        <div className="description-page">
            <Helmet>
                <title>{`Лог ${log?.id}`}</title>
            </Helmet>
            <div className="description-header">
                <BackButton onClick={() => history.goBack()}/>
            </div>

            <Descriptions bordered column={{xs: 1, sm: 1, md: 1, lg: 2}}>
                <Descriptions.Item label="Тип">{log?.nameLogType}</Descriptions.Item>
                <Descriptions.Item label="ID">{log?.id}</Descriptions.Item>
                <Descriptions.Item label="Оборудование">
                    <NavLink to={`/psLeakDevice/${log.idDevice}`}>{log.nameDevice}</NavLink>
                </Descriptions.Item>
                <Descriptions.Item label="Объект">
                    <NavLink to={`/object/${log.idObject}`}>{log.nameObject}</NavLink>
                </Descriptions.Item>
                <Descriptions.Item label="Группа">
                    <NavLink to={`/objectGroup/${log.idObjectGroup}`}>{log.nameObjectGroup}</NavLink>
                </Descriptions.Item>
                <Descriptions.Item label="Компания">
                    <NavLink to={`/company/${log.idCompany}`}>{log.nameCompany}</NavLink>
                </Descriptions.Item>
                <Descriptions.Item label="Дата" span={lg ? 2 : 1}>{`${moment(log.date).format('DD.MM.YYYY HH:mm')} ${getTimeZoneDiffString(log.timeZone)}`}</Descriptions.Item>
                <Descriptions.Item label="Описание">{log?.description}</Descriptions.Item>
            </Descriptions>
        </div>
    )
}